import CustomHead from "@/components/atoms/CustomHead"
import { type SbPageStory } from "../../../../types"
import { StoryblokBlokLooper } from "../../../StoryblokBlokLooper"

type PageTemplateProps = {
    story: SbPageStory
}

export function PageTemplate({ story }: PageTemplateProps) {
    const { blocks, metaRobots, metadata } = story.content

    return (
        <>
            <CustomHead
                title={metadata?.title}
                description={metadata?.description}
                robots={metaRobots?.join(",")}
            />
            <StoryblokBlokLooper
                required
                blocks={blocks}
            />
        </>
    )
}
